import React, {useEffect, useRef, useState, useCallback} from 'react';
import {connect} from "react-redux";

import Box from '@mui/material/Box';
import ReactMapGL, {NavigationControl, Popup} from "react-map-gl";
import 'mapbox-gl/dist/mapbox-gl.css';
import {setLocation, setMapPopupLocation, setMapPopupLocationAndGeocode} from "../../actions/map";
import PointPopup from "./point-popup";
import {setMarkers} from "../../actions/config";
import EndpointsOverlay from "./connected-endpoints-overlay";
import TransitiveOverlay from "../mapbox/overlays/transitive-overlay";
import RouteViewerOverlay from "../mapbox/overlays/route-viewer-overlay";
import DefaultStopMarker from '../../@opentripplanner/stop-viewer-overlay/src/default-stop-marker'
import StopViewerOverlay from "../mapbox/overlays/stop-viewer-overlay";
import BoundsUpdatingOverlay from "../mapbox/overlays/bounds-updating-overlay";
import TripViewerOverlay from "../mapbox/overlays/trip-viewer-overlay";
import {useNavigate} from "react-router-dom";
import { useQueryParams } from '../../hooks/useQueryParams';


function MapGL(props) {
  const {mapConfig, mapPopupLocation, isShowMarkers, viewedRoute, routes, locale} = props;
  const mapboxToken = mapConfig.token;

  const mapRef = useRef();
  const [map, setMap] = useState();
  const center = mapConfig && mapConfig.initLat && mapConfig.initLon
    ? {longitude: mapConfig.initLon, latitude: mapConfig.initLat, zoom: mapConfig.initZoom || 13}
    : null;

  const [viewState, setViewState] = useState(center);
  const [showPopup, setShowPopup] = useState(true);
  const [stops, setStops] = useState(null);

  const history = useNavigate();
  const { navigateWithParams } = useQueryParams();
  
  const onRender = useCallback(() => {
    const mapElem = mapRef?.current;
    if (!mapElem) return;
    setMap(mapElem)
  }, []);


  useEffect(() => {
    if (map && locale) {
      map.setLanguage(locale)
    }
  }, [map, locale]);

  useEffect(() => {
    if (viewedRoute && routes && routes[viewedRoute.routeId]
      && viewedRoute.pattern && routes[viewedRoute.routeId].patterns
      && routes[viewedRoute.routeId].patterns[viewedRoute.pattern]
      && routes[viewedRoute.routeId].patterns[viewedRoute.pattern].stops) {
      setTimeout(setMarkersBoolean, 500);

      setStops(routes[viewedRoute.routeId].patterns[viewedRoute.pattern].stops);
    }
  }, [viewedRoute, routes]);

  const setMarkersBoolean = () => {
    if (!isShowMarkers) {
      props.setMarkers(1);
    }
  };


  const onMapClick = (e) => {
    props.setMapPopupLocationAndGeocode(e);
    setShowPopup(true);
  };

  const onPopupClosed = () => {
    props.setMapPopupLocation({location: null});
    setShowPopup(false);
  };

  const onSetLocationFromPopup = (payload) => {
    props.setMapPopupLocation({ location: null });
    props.setLocation(payload);
    navigateWithParams("/plan");
  };

  return (
    <Box
      sx={{
        position: 'relative',
        height: '100%'
      }}>
      <ReactMapGL
        mapboxAccessToken={mapboxToken}
        {...viewState}
        onMove={e => {
          setViewState(e.viewState)
        }}
        maxZoom={mapConfig.maxZoom}
        mapStyle="mapbox://styles/nadavmos/ckg94xrm043cj19qu9wgfcnh7"
        ref={mapRef}
        onClick={onMapClick}
        onRender={onRender}
      >
        <NavigationControl showCompass={false} position={'top-left'}/>
        <BoundsUpdatingOverlay map={mapRef.current}/>

        {(showPopup && mapPopupLocation) && (
          <Popup longitude={mapPopupLocation.lon} latitude={mapPopupLocation.lat}
                 anchor="bottom"
                 onClose={onPopupClosed}>
            <PointPopup
              mapPopupLocation={mapPopupLocation}
              onSetLocationFromPopup={onSetLocationFromPopup}
            />
          </Popup>)}

        <EndpointsOverlay/>
        <TransitiveOverlay/>
        <RouteViewerOverlay map={mapRef.current}/>
        {(stops && isShowMarkers === 1 && viewedRoute && routes && routes[viewedRoute.routeId]) && (stops.map((stop, i) => {
            return (<StopViewerOverlay key={'stop' + i}
                                       index={i} stop={stop}
                                       StopMarker={DefaultStopMarker}
                                       markerStyle={{
                                         color: '#' + routes[viewedRoute.routeId].color,
                                         width: 10,
                                         height: 10,
                                         borderRadius: '100%',
                                         border: '3px solid',
                                         boxShadow: '0px 4px 4px rgb(0 0 0 / 25%)',
                                         background: '#FFFFFF',
                                         display: 'flex',
                                         cursor: 'pointer'
                                       }}/>)
          })
        )
        }
        <TripViewerOverlay/>

      </ReactMapGL>
    </Box>
  )
}

const mapStateToProps = (state, ownProps) => {
  const viewedRoute = state.otp.ui.viewedRoute;
  return {
    mapConfig: state.otp.config.map,
    mapPopupLocation: state.otp.ui.mapPopupLocation,
    isShowMarkers: state.otp.config.isShowMarkers,
    routes: viewedRoute ? state.otp.transitIndex.routes : null,
    locale: state.otp.currentQuery.locale,
    viewedRoute,
    ...state
  }
};
const mapDispatchToProps = {setMapPopupLocationAndGeocode, setMapPopupLocation, setLocation, setMarkers};
export default connect(mapStateToProps, mapDispatchToProps)(MapGL)